import { render, staticRenderFns } from "./Dozenteneinsatzliste.vue?vue&type=template&id=25d50c35&"
import script from "./Dozenteneinsatzliste.vue?vue&type=script&lang=js&"
export * from "./Dozenteneinsatzliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports